import type { MdmContactUse } from "@/types/cat/mdm-account.types";

export type { MdmContactUse };

export type PhoneContact = {
  value: string;
  use: MdmContactUse;
};

export const EMPTY_PHONE_CONTACT: PhoneContact = {
  value: "",
  use: "unknown",
};

export type PartyAddressProfile = {
  addressLine: string;
  addressFloorApartment: string;
  addressBuildingResidence: string;
  postBox: string;
  postalCode: string;
  city: string;
};

export const EMPTY_PARTY_ADDRESS: PartyAddressProfile = {
  addressLine: "",
  addressFloorApartment: "",
  addressBuildingResidence: "",
  postBox: "",
  postalCode: "",
  city: "",
};

export type EditableIndividualProfile = PartyAddressProfile & {
  email: string;
  fixedPhone: PhoneContact;
  mobilePhone: PhoneContact;
};

export type EditableIndividualWithIdentity = EditableIndividualProfile & {
  firstName: string;
  lastName: string;
};

export const EMPTY_EDITABLE_INDIVIDUAL_PROFILE: EditableIndividualProfile = {
  ...EMPTY_PARTY_ADDRESS,
  email: "",
  fixedPhone: { ...EMPTY_PHONE_CONTACT },
  mobilePhone: { ...EMPTY_PHONE_CONTACT },
};

export function firstNonEmptyPhone(
  fixed: PhoneContact,
  mobile: PhoneContact,
): string {
  return fixed.value.trim() || mobile.value.trim();
}
